/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Subtitle.scss'
import React from 'react'

function Subtitle(props) {
  return <h2 className="subTitle">{props.children}</h2>
}

export default Subtitle
